// La capa full-screen en la que MOBILE resuelve lo que en desktop se elige en el panel
// lateral — ADR-2026-09-10-los-modos-de-deco-en-el-telefono.
//
// La comparten "Variantes de acabado" y "Mostrar cómo funciona": los dos tienen paneles
// que NO son una lista de opciones —la paleta de acabados con su fondo, las tres maneras
// de terminar el video con su grilla— sino pantallas enteras, con su propio scroll y su
// propio pie de "Listo". Metidos en un bottom sheet quedaban con dos scrolls anidados
// (el del sheet y el suyo), y las pastillas de categoría, que scrollean su contenedor a
// mano, dejaban de funcionar porque el que scrolleaba era el de afuera.
//
// Por eso acá el contenido se monta TAL CUAL como en desktop: la capa es un
// `flex flex-col` a pantalla completa y el panel sigue siendo el mismo
// `flex-1 min-h-0 flex flex-col` que dibuja el modo. Cero variantes del contenido entre
// una pantalla y la otra.
//
// Lo que SÍ sigue siendo un bottom sheet es Formato: ya tiene el suyo (`FormatPicker`),
// es el mismo en toda la app y es una lista de opciones que commitea con el toque.
//
// Se portalea al `body` por lo mismo que `SheetLateral`: la pantalla del modo tiene su
// propio `overflow`, y montada adentro la capa quedaría recortada por él.

import type { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { useExitTransition } from '../../../../hooks/useExitTransition';

export function CapaModoMobile({
  abierta,
  onCerrar,
  titulo,
  children,
}: {
  abierta: boolean;
  onCerrar: () => void;
  titulo: string;
  children: ReactNode;
}) {
  // Mantiene la capa montada durante la animación de salida: sin esto, cerrar desmonta en
  // el acto y la transición inversa no llega a correr. El mismo hook y los mismos 300ms
  // que `SheetLateral`, para que las dos capas del modo se muevan igual.
  const { mounted, animated } = useExitTransition(abierta, 300);

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 z-[211] bg-white flex flex-col transition-transform duration-300 ease-out ${
        animated ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      {/* El header de iOS que ya usa `SheetLateral` en mobile: Cancelar · título ·
          spacer. Es la capa la que trae su back —el chrome flotante del shell queda
          DEBAJO de este z-index—, así que sin esta fila no habría cómo salir. */}
      <div className="shrink-0 flex items-center justify-between px-4 h-12 border-b border-black/[0.06]">
        <button
          type="button"
          onClick={onCerrar}
          className="text-[15px] text-brand-primary active:opacity-50 transition-opacity w-20 text-left"
        >
          Cancelar
        </button>
        <h3 className="min-w-0 truncate text-[15px] font-semibold text-brand-black/90">
          {titulo}
        </h3>
        <div className="w-20" />
      </div>
      {/* El contenido trae su propio scroll y su propio pie. `min-h-0` es lo que deja que
          ese scroll se recorte acá adentro en vez de empujar la capa. */}
      <div
        className="flex-1 min-h-0 flex flex-col"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}

export default CapaModoMobile;
